import { Action } from 'redux';
import { DeleteUserNotifications, DeleteUserNotificationsSucceeded } from '../../../app/actions/AppActionTypes';
import { IUserNotification } from '../../models/IUserNotification';
import { isActionFactory } from '../../../app/actions/isActionFactory';

export interface DeleteUserNotificationsAction extends Action {
    notificationIds: string[];
 }

export interface DeleteUserNotificationsSucceededAction extends Action {
    notificationIds: string[];
}

export function deleteUserNotificationsAction(ids: string[]): DeleteUserNotificationsAction {
  return {
    type: DeleteUserNotifications,
    notificationIds: ids,
  };
}

export function deleteUserNotificationsSucceededAction(ids: string[]): DeleteUserNotificationsSucceededAction {
  return {
    type: DeleteUserNotificationsSucceeded,
    notificationIds: ids,
  };
}

export const isDeleteUserNotificationsAction = isActionFactory<DeleteUserNotificationsAction>(DeleteUserNotifications);

export const isDeleteUserNotificationsSucceedAction = isActionFactory<DeleteUserNotificationsSucceededAction>(DeleteUserNotificationsSucceeded);